
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/seo",
      function () {
        return require("private-next-pages/services/seo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/seo"])
      });
    }
  